"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.create_view_session = void 0;
const store_1 = require("../../../store");
const api_1 = require("../../api");
/**
 * Create a FaceTec VIEW session (for viewing published documents)
 * Uses MongoDB-only backend (sky_sign_api)
 *
 * This creates a VIEW session by calling the LOGIN endpoint.
 * The backend returns type "LOGIN" but we treat it as a VIEW session for clarity.
 * Required for accessing documents via TYPE_LINK (inbox "Sign Now" links).
 */
function create_view_session() {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const { userState } = store_1.redux_store.getState();
        const { token } = userState;
        // Backend endpoint is /login but returns a session for viewing documents
        const response = yield new api_1.API().apiPost({
            baseUrl: (_a = process.env.API_URL) !== null && _a !== void 0 ? _a : "",
            endpoint: "facetec/session/login",
            content: {},
            authorization: `${token}`,
        });
        // Backend returns type "LOGIN" but we map it to "VIEW" for frontend consistency
        if (((_b = response === null || response === void 0 ? void 0 : response.session) === null || _b === void 0 ? void 0 : _b.type) === "LOGIN") {
            response.session.type = "VIEW";
        }
        return response;
    });
}
exports.create_view_session = create_view_session;
